<template>
    <div :class="['j-file-style', type]">
        <div v-if="type === 'list'" class="j-file-style-list">
            <img class="j-file-style-list_icon" :src="fileIcon" :alt="fileSuffix">
            <span class="j-file-style-list_name" :title="fileName" @click="clickEvent">{{fileName}}</span>
            <span class="j-file-style-list_ctrl">
                <slot />
            </span>
        </div>
        <div v-else-if="type === 'card'" class="j-file-style-card" :title="fileName">
            <img :class="{ 'j-file-style-card_icon': true, 'j-file-style-card_image': isImage }" :src="isImage ? fileUrl : fileIcon" :alt="fileSuffix">
            <span class="j-file-style-card_ctrl">
                <i v-if="filePreview" class="el-icon-zoom-in" @click="handlePreview" />
                <i v-else class="el-icon-download" @click="handleDownload" />
                <slot />
            </span>
        </div>
        <div v-else class="j-file-style-icon">
            <img class="j-file-style-icon_icon" :src="fileIcon" :alt="fileSuffix" @click="clickEvent">
            <span class="j-file-style-icon_name" :title="fileName" @click="clickEvent">{{fileName}}</span>
            <span class="j-file-style-icon_ctrl">
                <slot />
            </span>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import { fls, flsPathSuffix } from "@/config";
    import fileType from "./js/fileType";
    import file from "../JTool/file/file";
    import oss from "../JTool/oss/oss";
    import "../JImagePreview/JImagePreview";
    export default {
        name: "JFile",
        componentName: 'JFile',
        props: {
            type: { // [list, card, icon]
                type: String,
                default: 'list'
            },
            name: {
                type: String,
            },
            suffix: {
                type: String,
            },
            src: {
                type: String,
                required: true
            },
            useFully: { // 使用全路径，将不会使用文件服务解析拼接，适合非文件服务地址
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                isImage: false,
                filePreview: false,
                fileUrl: '',
                fileSuffix: '',
                fileName: '',
                fileIcon: '',
                fileInfo: {}
            }
        },
        watch: {
            src () {
               this.handleInit()
            }
        },
        created() {
            this.handleInit()
        },
        methods: {
            handleInit () {
                if (!this.name || !this.suffix) this.fileInfo = file.getFileInfoByUrl(this.src)
                this.fileName = this.name || this.fileInfo.fileName
                this.fileSuffix = this.suffixFormat(this.suffix || this.fileInfo.fileSuffix)
                this.filePreview = fileType.fileSuffix.image.includes(this.fileSuffix) // 目前仅支持图片预览
                this.isImage = fileType.fileSuffix.image.includes(this.fileSuffix)
                this.fileIcon = fileType.fileTypeIcon[fileType.suffixMimeTypeMap[this.fileSuffix] || 'unknown']
                if (this.useFully) this.fileUrl = this.src
                else this.fileUrl = oss.getUrlByGenerateName(this.src)
            },
            suffixFormat (suffix) {
                let s = suffix.toLowerCase()
                return s.startsWith('.') ? s : `.${s}`
            },
            clickEvent () {
                if (this.filePreview) this.handlePreview()
                else this.handleDownload()
            },
            handlePreview () {
                const srcList = []
                this.$parent.$children.forEach(vnode => {
                    if (vnode.$options._componentTag === 'j-file' && vnode.isImage) srcList.push({ src:vnode.fileUrl, title: vnode.fileName })
                })
                console.log(srcList)
                this.$JImagePreview({ srcList, index: srcList.findIndex(item => item.src === this.fileUrl) })
            },
            handleDownload () {
                if (this.fileSuffix === '.txt') { // txt单独处理
                    this.downloadTxt(file)
                } else { // 非图片走下载逻辑
                    file.fileDownloadByUrl(this.fileUrl, this.fileName)
                }
            },
            handleFully (fully) {
                let tempName = fully.replace(fls, '').split('/')
                let tempBucket = tempName.slice()
                return {
                    bucketName: tempBucket.splice(0, 2).join(''),
                    fileName: tempName.splice(2).join('/')
                }
            },
            async downloadTxt () {
                let data
                if (this.useFully)  {
                    const { bucketName, fileName } = this.handleFully(this.fileUrl)
                    data = await axios.request({
                        method: 'get',
                        url: `/api/files/object?bucketName=${bucketName}&fileName=/${fileName}`,
                        responseType: 'blob',
                        notProcessed: true // axios不统一处理请求返回操作
                    })
                } else {
                    data = await axios.request({
                        method: 'get',
                        url: `/api/files/object?fileName=/${flsPathSuffix && (flsPathSuffix + '/')}${this.src}`,
                        responseType: 'blob',
                        notProcessed: true // axios不统一处理请求返回操作
                    })
                }
                let url = window.URL.createObjectURL(data.data)
                let link = document.createElement('a')
                link.style.display = 'none'
                link.href = url
                // link.target = "_blank"
                link.setAttribute('download', this.fileName)
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link) // 下载完成移除元素
                window.URL.revokeObjectURL(url) // 释放掉blob对象
            }
        }
    }
</script>

<style lang="scss">
    .j-file-style {
        cursor: pointer;
        &.list {
            height: 28px;
            border-radius: 4px;
            transition: all .2s linear;
            + .list {
                margin-top: 4px;
            }
            &:hover {
                .j-file-style-list .j-file-style-list_name {
                    color: #2CA2F2;
                }
                background-color: rgb(236, 245, 255);
            }
            .j-file-style-list {
                height: 100%;
                display: flex;
                align-items: center;
                padding: 0 5px;
                .j-file-style-list_icon {
                    height: 20px;
                }
                .j-file-style-list_name {
                    flex: 1;
                    min-width: 50px;
                    margin: 0 5px;
                    color: #606266;
                    font-size: 14px;
                    overflow:hidden; //超出的文本隐藏
                    text-overflow:ellipsis; //溢出用省略号显示
                    white-space:nowrap; //溢出不换行
                    transition: color .3s linear;
                }
                .j-file-style-list_ctrl {
                    color: #606266;
                    font-size: 14px;
                    > i {
                        + i {
                            margin-left: 2px;
                        }
                        transition: color .2s linear;
                        &:hover {
                            color: #2CA2F2;
                        }
                    }
                }
            }
        }
        &.card {
            display: inline-flex;
            width: 80px;
            height: 80px;
            background-color: rgb(236, 245, 255);
            border-radius: 4px;
            margin: 5px 5px 0 0;
            vertical-align: text-bottom;
            &:hover {
                .j-file-style-card .j-file-style-card_ctrl {
                    opacity: 1;
                }
            }
            .j-file-style-card {
                position: relative;
                width: 100%;
                height: 100%;
                border-radius: 4px;
                background-position: 0 0,5px 5px!important;
                background-size: 10px 10px!important;
                background-image: linear-gradient(45deg,#eee 25%,transparent 25%,transparent 75%,#eee 75%,#eee 100%),linear-gradient(45deg,#eee 25%,#fff 25%,#fff 75%,#eee 75%,#eee 100%)!important;
                .j-file-style-card_image.j-file-style-card_icon {
                    object-fit: cover;
                }
                .j-file-style-card_icon {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                    border-radius: 4px;
                }
                .j-file-style-card_ctrl {
                    opacity: 0;
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    flex-wrap: wrap;
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background-color: rgba(0,0,0,.4);
                    backdrop-filter: blur(2px);
                    border-radius: 4px;
                    color: #dadada;
                    transition: all .2s linear;
                    > i {
                        font-size: 16px;
                        margin: 0 4px;
                        transition: color .2s linear;
                        &:hover {
                            color: #fff;
                        }
                    }
                }
            }
        }
        &.icon {
            position: relative;
            display: inline-flex;
            width: 80px;
            max-height: 70px;
            padding: 14px 5px 8px;
            margin: 2px 2px 0 0;
            border-radius: 4px;
            transition: all .2s linear;
            vertical-align: text-top;
            &:hover {
                .j-file-style-icon .j-file-style-icon_name {
                    color: #2CA2F2;
                }
                background-color: rgb(236, 245, 255);
            }
            .j-file-style-icon {
                display: flex;
                flex-direction: column;
                align-items: center;
                width: 100%;
                .j-file-style-icon_icon {
                    width: 40px;
                    height: 40px;
                }
                .j-file-style-icon_name {
                    flex: 1;
                    min-height: 14px;
                    width: 100%;
                    text-align: center;
                    line-height: 14px;
                    color: #606266;
                    font-size: 12px;
                    margin-top: 2px;
                    display:-webkit-box;         //将对象作为弹性伸缩盒子模型显示。
                    -webkit-box-orient:vertical; //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
                    -webkit-line-clamp: 2;      //几行换行（注意必须设置行高）
                    word-break: break-all;
                    overflow:hidden; //超出的文本隐藏
                    text-overflow:ellipsis; //溢出用省略号显示
                    transition: color .3s linear;
                }
                .j-file-style-icon_ctrl {
                    position: absolute;
                    top: 3px;
                    right: 3px;
                    font-size: 12px;
                    color: #606266;
                    opacity: .8;
                    > i {
                        + i {
                            margin-left: 2px;
                        }
                        transition: color .2s linear;
                        &:hover {
                            color: #2CA2F2;
                        }
                    }
                }
            }
        }
    }
</style>
